// extracted by mini-css-extract-plugin
export var csatScore = "_jh-5";
export var header = "_jh-1";
export var panelWrapper = "_jh-2";
export var postPreview = "_jh-3";
export var rightContent = "_jh-0";
export var wrappingText = "_jh-4";